// extracted by mini-css-extract-plugin
export var contactRow = "contact-module--contact-row--PQZlS";
export var contactColumns = "contact-module--contact-columns--LAs3E";
export var leftColumn = "contact-module--left-column--1YPYN";
export var contactItems = "contact-module--contact-items--27cN2";
export var rightColumn = "contact-module--right-column--2BPk7";